import React, { FC, useState, useEffect } from 'react';
import { Box, Typography, Button, Snackbar, Alert } from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';
import { WalletStyles } from '../styles';
import { homenetwork, homepvtKey } from '../../../Headerr';
import { bsv } from '../../../scrypt-ts-this/distthis/index';

const WalletReceive: FC = () => {
  const [address, setAddress] = useState<string>('');
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (homepvtKey.length === 64) {
      try {
        const privateKey = bsv.PrivateKey.fromHex(homepvtKey, homenetwork);
        setAddress(bsv.Address.fromPrivateKey(privateKey).toString());
      } catch (e) {
        console.error('Failed to derive address:', e);
      }
    }
  }, []);

  const handleCopy = async () => {
    if (address) {
      try {
        await navigator.clipboard.writeText(address);
        setCopied(true);
      } catch (e) {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = address;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        setCopied(true);
      }
    }
  };

  if (!address) {
    return (
      <Box sx={WalletStyles.card}>
        <Typography sx={WalletStyles.noDataText}>
          Insira sua chave privada nas credenciais para ver seu endereço de recebimento.
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Box sx={WalletStyles.card}>
        <Typography sx={WalletStyles.sectionTitle}>Receber BSV</Typography>

        <Box sx={WalletStyles.qrContainer}>
          <Box sx={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '12px',
            display: 'inline-block',
          }}>
            {/* @ts-ignore */}
            <QRCodeSVG
              value={address}
              size={220}
              level="M"
              fgColor="#333333"
              bgColor="#ffffff"
            />
          </Box>

          <Typography variant="body2" sx={{
            color: '#7BA238',
            wordBreak: 'break-all',
            textAlign: 'center',
            fontSize: '0.85rem',
            maxWidth: '300px',
            fontFamily: 'monospace',
          }}>
            {address}
          </Typography>

          <Button
            variant="contained"
            onClick={handleCopy}
            sx={WalletStyles.actionButton}
          >
            📋 Copiar Endereço
          </Button>
        </Box>
      </Box>

      <Snackbar
        open={copied}
        autoHideDuration={2000}
        onClose={() => setCopied(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity="success" onClose={() => setCopied(false)}>
          Endereço copiado!
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default WalletReceive;
